module.exports = __webpack_public_path__ + "static/img/url4.7ba92dad.png";